
import React from 'react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';
import { supabase } from '@/lib/supabase';

interface QuickSubmissionFormProps {
  email: string;
  setEmail: (email: string) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  quickSubmission: any;
  quickSubmissionId: string | null;
}

const QuickSubmissionForm = ({ 
  email, 
  setEmail, 
  loading, 
  setLoading,
  quickSubmission,
  quickSubmissionId
}: QuickSubmissionFormProps) => {
  
  const sendMagicLink = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) {
      toast.error('Please enter your email address');
      return;
    }
    
    setLoading(true);
    
    try {
      const { error } = await supabase.auth.signInWithOtp({
        email,
        options: {
          emailRedirectTo: `${window.location.origin}/job-seeker-dashboard`,
          data: {
            role: 'job_seeker',
            from_quick_submission: quickSubmissionId || null
          }
        }
      });
      
      if (error) {
        throw error;
      }
      
      toast.success('Magic link sent! Check your email to sign in.', {
        duration: 6000,
        description: 'Please check your email inbox and click on the link to sign in.'
      });
    } catch (error: any) {
      console.error('Magic link error:', error);
      toast.error('Failed to send magic link. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className="bg-green-50 p-4 rounded-md border border-green-200 mb-4">
        <p className="text-green-800 text-sm">
          We found your resume submission! Create your account to track your application status.
        </p>
      </div>
      
      <form onSubmit={sendMagicLink} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="magic-email">Email</Label>
          <Input 
            id="magic-email" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            type="email" 
            placeholder="your@email.com"
            required
            readOnly={!!quickSubmission}
          />
        </div>
        
        <Button type="submit" className="w-full bg-mint text-forest hover:bg-mint/90" disabled={loading}>
          {loading ? 'Sending...' : 'Send Magic Link'}
        </Button>
      </form>
    </div>
  );
};

export default QuickSubmissionForm;
